"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Yields a function that interprets a string expression as an LDflex path.
 */

var StringToLDflexHandler =
/*#__PURE__*/
function () {
  function StringToLDflexHandler() {
    _classCallCheck(this, StringToLDflexHandler);
  }

  _createClass(StringToLDflexHandler, [{
    key: "handle",
    value: function handle(pathData, path) {
      // Resolves the given string expression against the LDflex object
      return function () {
        var expression = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var ldflex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : path;
        // An expression starts with a property access in dot or bracket notation
        var propertyPath = expression // Add brackets around a single URL
        .replace(/^(https?:\/\/[^()[\]'"]+)$/, '["$1"]') // Add the starting dot if omitted
        .replace(/^(?=[a-z$_])/i, '.') // Add quotes inside of brackets if omitted
        .replace(/\[([^'"`\](]*)\]/g, '["$1"]'); // Create a function to evaluate the expression

        var body = "\"use strict\";return ldflex".concat(propertyPath);
        var evaluator;

        try {
          /* eslint no-new-func: off */
          evaluator = Function('ldflex', body);
        } catch (_ref) {
          var message = _ref.message;
          throw new Error("Expression \"".concat(expression, "\" is invalid: ").concat(message));
        } // Evaluate the function


        return evaluator(ldflex);
      };
    }
  }]);

  return StringToLDflexHandler;
}();

exports.default = StringToLDflexHandler;